// Short nl-BE date (dd/mm) for an ISO string; "—" for null/invalid.
export function shortDate(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('nl-BE', { day: '2-digit', month: '2-digit' })
}

// Full nl-BE date (dd/mm/yyyy) for an ISO string; "—" for null/invalid.
export function longDate(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

// "2026-09-12" → "zaterdag 12 september 2026"; '' voor leeg/ongeldig, zodat
// elke zin kan terugvallen op een formulering zonder datum in plaats van een
// halve datum af te drukken. Spiegelt formatEventDateNl() in server/util.ts —
// die stuurt het label voor de *lopende* editie al mee in `season`; dit is
// voor de andere jaartallen in /beheer.
//
// timeZone: 'UTC' is niet optioneel: 'yyyy-mm-dd' parst als UTC-middernacht,
// dus in een zone vóór UTC zou de browser er de dag ervoor van maken.
export function nlDatum(iso: string | null | undefined): string {
  if (!iso) return ''
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim())
  if (!m) return ''
  const d = new Date(`${m[1]}-${m[2]}-${m[3]}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('nl-BE', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  })
}

// Dezelfde datum zonder jaartal: "12 september". Voor zinnen die de editie al
// benoemen en waar het jaartal enkel ruis is ("Tot 12 september!").
export function nlDagMaand(iso: string | null | undefined): string {
  if (!iso) return ''
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim())
  if (!m) return ''
  const d = new Date(`${m[1]}-${m[2]}-${m[3]}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('nl-BE', { day: 'numeric', month: 'long', timeZone: 'UTC' })
}
